"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var rs = require("./responsive.scss");
var element_children_1 = require("../util/element-children");
var dom_ready_1 = require("../util/dom-ready");
//@ts-ignore
require("../theme.ts");
var Row = /** @class */ (function (_super) {
    __extends(Row, _super);
    function Row() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Row.prototype.installed = function () {
        var _this = this;
        dom_ready_1.domReady(function () {
            var children = element_children_1.elementChildren(_this);
            children.forEach(function (child, index) {
                if (!child.hasAttribute('slot')) {
                    child.setAttribute('slot', index + '');
                }
            });
            _this.update();
        });
    };
    Row.prototype.render = function (props) {
        var _a;
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, props.type === 'flex' ? 'flex' : 'block', (_a = {},
            _a['flex-' + props.justify] = props.justify,
            _a['flex-' + props.align] = props.align,
            _a))), props.cols.map(function (_, index) {
            var _a;
            var style = props.gutter !== undefined ? {
                style: "padding-left: " + props.gutter / 2 + "px; padding-right: " + props.gutter / 2 + "px;"
            } : null;
            var classes = {};
            ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
                var _a;
                var sizeProps = {};
                if (typeof _[size] === 'number') {
                    sizeProps.span = _[size];
                }
                else if (typeof _[size] === 'object') {
                    sizeProps = _[size] || {};
                }
                classes = __assign(__assign({}, classes), (_a = {}, _a["col-" + size + "-" + sizeProps.span] = sizeProps.span !== undefined, _a["col-" + size + "-offset-" + sizeProps.offset] = sizeProps.offset || sizeProps.offset === 0, _a["col-" + size + "-push-" + sizeProps.push] = sizeProps.push || sizeProps.push === 0, _a["col-" + size + "-pull-" + sizeProps.pull] = sizeProps.pull || sizeProps.pull === 0, _a));
            });
            return omi_1.h("div", __assign({}, style, { class: omi_1.classNames("col", __assign((_a = {}, _a['col' + _.span] = _.span !== undefined, _a['col' + _] = typeof _ === 'number', _a['offset' + _.offset] = _.offset !== undefined, _a['push' + _.push] = _.push !== undefined, _a['pull' + _.pull] = _.pull !== undefined, _a), classes)) }),
                omi_1.h("slot", { name: index }));
        })));
    };
    Row.css = css + rs;
    Row.propTypes = {
        cols: Object,
        gutter: Number,
        justify: String,
        align: String,
        type: String
    };
    Row = __decorate([
        omi_1.tag('m-row')
    ], Row);
    return Row;
}(omi_1.WeElement));
exports.default = Row;
